import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ErrorHandler, ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { CustomHttpInterceptor, DEFAULT_TIMEOUT } from './interceptor/custom-http.interceptor';
import { GlobalErrorHandler } from './utils/global-error-handler';
import { throwIfAlreadyLoaded } from './utils/module-import-guard';
import { MasterDataApi } from '@cores/services/common-category/master-data.api';

export const CORE_PROVIDERS = [
  {
    provide: ErrorHandler,
    useClass: GlobalErrorHandler,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: CustomHttpInterceptor,
    multi: true,
  },
  { provide: DEFAULT_TIMEOUT, useValue: 60000 },
  Title,
];

@NgModule({
  imports: [CommonModule],
  declarations: [],
  providers: [MasterDataApi],
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    throwIfAlreadyLoaded(parentModule, 'CoreModule');
  }

  static forRoot(): ModuleWithProviders<CoreModule> {
    return {
      ngModule: CoreModule,
      providers: [...CORE_PROVIDERS],
    };
  }
}
